export default {
  API_RESOURCE: 'users'
}
